// extracted by mini-css-extract-plugin
export default {"container":"Fl-z","blurb":"Gl-z","links":"Hl-z"};